import { defineStore } from 'pinia';

export const useUserPreferencesStore = defineStore('userPreferences', {
    state: () => ({
        translation: 'KJV', // Default
        defaultView: 'card' // Default
    }),
    actions: {
        init() {
            const saved = localStorage.getItem('userPreferences');
            if (saved) {
                try {
                    const parsed = JSON.parse(saved);
                    if (parsed.translation) this.translation = parsed.translation;
                    if (parsed.defaultView) this.defaultView = parsed.defaultView;
                } catch (e) {
                    console.error("Failed to parse preferences", e);
                }
            }
        },
        async setTranslation(code) {
            this.translation = code;
            this.save();

            // Sync with auth profile if logged in
            // We need to dynamically import or use the store
            // Pinia stores can use other stores.
            const { useAuthStore } = await import('./auth');
            const authStore = useAuthStore();
            if (authStore.isAuthenticated) {
                authStore.updateProfile({ preferredTranslation: code });
            }
        },
        setDefaultView(view) {
            this.defaultView = view;
            this.save();
        },
        save() {
            localStorage.setItem('userPreferences', JSON.stringify({
                translation: this.translation,
                defaultView: this.defaultView
            }));
        }
    }
});
